import { useEffect, useMemo, useState } from "react";

import { hasSuppressionListPermissions } from "app/components/SideBar/utils";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

import { getAccessToCRMs } from "../utils/getAccessToCRMs";

type ManagementSectionAccess = "suppressionList" | CrmIntegrationProvider;

export function useHasManagementAccess(managementSection: ManagementSectionAccess) {
    const [hasAccess, setHasAccess] = useState(false);

    const suppressionList = hasSuppressionListPermissions();
    const { salesforce, hubspot, dynamics } = getAccessToCRMs();

    const allManagementAccesses = useMemo(
        () => ({
            suppressionList,
            salesforce,
            hubspot,
            dynamics,
        }),
        [suppressionList, salesforce, hubspot, dynamics],
    );

    useEffect(() => {
        setHasAccess(allManagementAccesses[managementSection]);
    }, [managementSection, allManagementAccesses]);

    return [hasAccess];
}
